import { BannersListContainer } from '@/modules/Banners';

const BannersList = (): JSX.Element => <BannersListContainer />;

export default BannersList;
